import { isReactNativeApp, subscribeToNative } from '@mobi/web-native-comms/web'
import { store } from '@core/Store'
import { AppRoutes } from '@core/AppRoutes'
import { OverlayClose } from '@core/Components/Overlay'
import { closeAllModals } from '@core/Components/Modal'
import { toggleIsDropDownOpen, toggleIsHamburgerMenuOpen } from '@core/Areas/AppHeader/Store'
import { setIsLoginShown } from '@core/Areas/Login/Store'
import { navigateToLastRacesPath } from '@core/State/Navigation/helpers/navigateToLastRacesPath'
import { autoOptInMarketingCommunications } from '@core/Areas/Account/MyPreferences/helpers/autoOptInMarketingCommunications'
import { navigateToSportsPath } from '@core/State/Navigation/helpers/navigateToSportsPath'
import { appHistory } from '@core/Utils/routing/history'

export const startDeepLinkingListeners = (): void => {
  if (isReactNativeApp) {
    subscribeToNative('DEEP_LINK_OPEN', deepLinkHandler)
    subscribeToNative('NAVIGATE_WEB_RACES', navigateToLastRacesPath)
    subscribeToNative('NAVIGATE_WEB_SPORTS', navigateToSportsPath)
  }
}

export const deepLinkHandler = ({ url }: { url: string }) => {
  try {
    closeAllPopups()

    const isRelativePath = url.startsWith('/')
    const urlObject = new URL(isRelativePath ? `urn://${url}` : url)

    const { pathname, search } = normalizeHashPaths(urlObject)

    if (pathname.includes(AppRoutes.MarketingCommunicationsOptIn)) {
      autoOptInMarketingCommunications()
      return
    }

    appHistory.push({ pathname, search })
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Bad deep link', e)
  }
}

// =============
// Local Helpers
// =============

function closeAllPopups() {
  OverlayClose()
  store.dispatch(toggleIsHamburgerMenuOpen(false))
  store.dispatch(toggleIsDropDownOpen(false))
  store.dispatch(closeAllModals())
  store.dispatch(setIsLoginShown({ shouldShow: false }))
}

/**
 * Converts hash routing url and to a standard browser url.
 * Required in Web for older Native versions not containing updated routes
 * */
function normalizeHashPaths(url: URL) {
  const { origin, pathname, hash } = url
  if (pathname === '/' && hash !== '') {
    const newOrigin = origin === 'null' ? 'urn://' : origin
    return new URL(`${newOrigin}${pathname}${hash.substring(1)}`)
  } else {
    return url
  }
}
